import { FaucetBlock } from './components/FaucetBlock/FaucetBlock';
import { Layout } from './components/Layout/Layout';

export const App = () => {
  return (
    <Layout>
      <FaucetBlock />
    </Layout>
  );
};
